import { defineBreadcrumb, useSchemaOrg } from '@unhead/schema-org/vue';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

export function useBreadcrumbSchema(breadcrumbRoutes) {
    // const route = useRoute();

    const breadcrumbSchema = computed(() => {
        const items = breadcrumbRoutes.value.map((route) => {
            const path = route.path || `/${route.params?.lang}/${route.name}`;

            return {
                name: route.meta.breadcrumb || route.name,
                item: path,
            };
        });

        return defineBreadcrumb({
            itemListElement: items,
        });
    });

    useSchemaOrg([breadcrumbSchema.value]);

    return {
        breadcrumbSchema,
    };
}
